/**
 * Which side of a proposal a team template is a team for.
 *
 * Both sides have a roster of the same shape — the vendor's negotiable Vendor Team and the client's
 * own Client Team — so one template concept serves both. What must never blur is which is which: a
 * firm's internal client-side roster is not something to offer a vendor's template picker.
 *
 * **Nothing here does the separating.** A panel sends its party with the query and is handed the rows
 * the server decided to send; `TeamTemplateFilterParameters.party` defaults to `Vendor` on the server
 * too, so a request that forgets to say cannot come back holding client templates. This enum exists
 * to say what to ask for, not to sort what arrived.
 *
 * The values are the names the API's `TeamTemplateParty` serializes as.
 */
export enum TeamTemplateParty {
  Vendor = "Vendor",
  Client = "Client",
}
